/**
 *    Sticky
 *
 *    @tableofcontent
 *      1. Dependencies
 *      2. Functions
 *       2.1 Init
 *       2.2 Sticky
 *       2.3 Sticky elements
 *
 */


/**
 *     @section 1. Dependencies
 */

import Constants from '../settings/_variables';
import '../../../node_modules/sticky-kit/dist/sticky-kit.min.js';


/**
 *     @section 2. Functions
 */

export default {

    // @section 2.1 Init
    init() {
        // console.log('sticky loaded ...');

        this.sticky();
        this.stickyElements();
    },

    // @section 2.2 Sticky
    sticky() {
        let self = this,
            $window = $(window),
            $body = $(document.body),
            // $stickyElements = $(`.${Constants.prefix}sticky`),
            $stickyAniElements = $(`.${Constants.prefix}sticky.${Constants.prefix}viewport--animation`);

        // call function on resize
        $window.on('resize', function() {
            let device = $body.attr('data-size');

            if(device === 'xs' || device === 'sm') {
                $stickyAniElements.trigger('sticky_kit:detach');
            } else {
                // recreate sticky behavior
                self.stickyElements();
            }
        });
    },

    // @section 2.3 Sticky elements
    stickyElements() {
        let $stickyElements = $(`.${Constants.prefix}sticky`);

        // make it sticky
        $stickyElements.stick_in_parent({
            offset_top: 100,
            // custom 'stuck' class
            sticky_class: `${Constants.prefix}sticky--is-stuck`
        }).on('sticky_kit:bottom', function(e) {
            // add custom 'bottom reached' class
            $(e.target).addClass(`${Constants.prefix}sticky--bottom-reached`);
        }).on('sticky_kit:unbottom', function(e) {
            // remove custom 'bottom reached' class
            $(e.target).removeClass(`${Constants.prefix}sticky--bottom-reached`);
        });
    }
};

// end of _sticky.js
